<template>
<section class="content">
  <div class="box box-info">
    <propertySetup ref="propertySetup" />
    <propertyList @delete-message="deleteProperty" @edit-property="editItemProperty" ref="deleteData" />
  </div>
</section>
</template>
<script>
import propertySetup from './propertySetup.vue'
import propertyList from './propertyList.vue'
// import accountgroupdialog from '../accountDialog/AccountGroupDialog.vue'
export default {
  name: 'itemProperty',
  data() {
    return {}
  },
  methods: {
    editItemProperty(data) {
      this.$refs.propertySetup.openItemPropertySetup(data)
    },
    deleteProperty(value) {
      this.$toast.add({
        severity: value.messageType,
        summary: '',
        detail: value.message,
        life: 10000
      })
    }
  },
  components: {
    propertySetup,
    propertyList
    // accountgroupdialog
  }
}
</script>



// WEBPACK FOOTER //
// property.vue?5f786f49